import {
  AfterContentInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { IBaseService } from '../../../core/service/ibase-service';
import { AbstractBaseAddUpdateComponent } from '../../../core/component/abstract-base-add-update-component';
import { SalesOrderModal } from '../modal/sales-order-modal';
import { SalesOrderServiceService } from '../service/sales-order-service.service';
import { PartyModal } from '../../party/modal/party-modal';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SoDetailModal } from '../modal/so-detail-modal';
import { CommonSelectListService } from '../../../shared/service/common-select-list.service';
import { ResponseCode } from '../../../core/constant/response-code';
import { Organization } from '../../purchase-order/modal/organization';
import { environment } from '../../../../environments/environment';
import { UrlsConstant } from '../../../shared/add-refresh/constant/urls-constant.enum';
import { CustomParametersDetailsModel } from '../../../shared/custom-param-detail/model/custom-parameters-details-model';
import { SalesOrderQualityParamDetailsModel } from '../modal/sales-order-quality-param-details.model';
import { PackingModel } from '../../packing/model/packing-model';
import { PackingDetailModel } from '../../packing/model/packing-detail-model';
import { SystemConfigService } from '../../../system-config/service/system-config.service';
import { soModuleParamConfigModel } from '../modal/so-module-param-config-model';
import { ModuleParamGlobConfigService } from '../../../core/service/moduleFieldConfig/module-param-glob-config.service';
import { SystemConfigSettingModel } from '../../../shared/model/system-config-setting-model';
import { UserModal } from '../../user/modal/user-modal';
import { ACLService } from '../../../shared/AclService/acl.service';
import { ModuleUrlsConstant } from '../../../shared/add-refresh/constant/module-urls-constant';
import { OrgProfileModal } from '../../org-profile/modal/org-profile-modal';
import { BranchModel } from '../../branch/model/branch-model';
import { LocationMasterModel } from '../../location/model/location-master-model';
import { CBLSelectionComponent } from '../../../shared/company-branch-location/cblselection/cblselection.component';
import { ItemProperties, ItemPropertyValues } from '../../funnel/modal/funnel-modal';
import { ProductModal } from '../../product/modal/product-modal';
import { DispatchDetailsModal } from '../../dispatch/modal/dispatch-details-modal';
import { ArrayUtils } from '../../../core/util/array-utils';
import { ConfirmDialogService } from 'src/app/shared/confirm-dialog-box/service/confirm-dialog.service';
import { SOMailModel } from '../modal/so-mail-model';
import { ProductionBatchOptimisedModal } from '../../production-batch/model/production-batch.model';
import { InwardStockFilterList } from '../../inward-stock/modal/inward-stock-filter-list';
import { InwardStockModal } from '../../inward-stock/modal/inward-stock-modal';
import { InwardStockByName } from '../../inward-stock/modal/inward-stock-by-name';
import { UomModal } from 'src/app/core/modal/uom-modal';
import { UomConstModal } from 'src/app/core/modal/uom-const-modal';
import { FreightModal } from '../../freight/modal/freight-modal';
import { PartyDetailModal } from '../../party/modal/party-detail-modal';
import { DynamicParams } from '../sales-order-print/sales-order-print.component';

const amendedPoNo = 'amendedPoNo.';
const amendedPoDate = 'amendedPoDate';
const selectedDeliveryNote = 'selectedDeliveryNote';
const selectedDocumentNotes = 'selectedDocumentNotes';
const spiIns = 'spiIns';
const items = 'item';
const moduleName = 'SalesOrder';
@Component({
  selector: 'app-sales-order-add-update',
  templateUrl: './sales-order-add-update.component.html',
  styleUrls: ['./sales-order-add-update.component.css'],
})
export class SalesOrderAddUpdateComponent
  extends AbstractBaseAddUpdateComponent<SalesOrderModal>
  implements OnInit, AfterContentInit
{
  private readonly MODULE_PARAM_CONFIG_KEY: string = 'salesOrder';
  public propertyUrls = ModuleUrlsConstant;
  @Input() sodata:SalesOrderModal;
  @Input() getAllFilter: boolean;
  @Output('onSalesSave') onSaveCallBack: EventEmitter<void> = new EventEmitter<void>();
  @Input() selectedParty: PartyModal;
  @Input() isModelComponent:boolean;
  @ViewChild(CBLSelectionComponent) cblChild: CBLSelectionComponent;

  public formGroup: FormGroup;
  public data: SalesOrderModal;
  public printData: SalesOrderModal;
  public partyList: Array<PartyModal>;
  private ngbRef: NgbModalRef;
  productDetail: SoDetailModal;
  public targetProductIndex = -1;
  public isVendorCodeOn: boolean;
  public isPackingTypeSupport: boolean;
  public isRollNoSupport: boolean;
  public isSecondaryStockSupport: boolean;
  public totalWeight: number;
  public freightTypeList: Array<FreightModal>;
  public transporterList: Array<{ id: number; name: string }>;
  public totalSecondaryWeight: number;
  public totalCost: number;
  public totalPrice: number;
  public termData: string;
  public todayDate:any = new Date();
  public remark: string;
  public bank: Array<Organization>;
  public companyName: string;
  urls = UrlsConstant;
  public isSecondaryQuantity: boolean;
  public isDispatch: boolean;
  selectedMaterialId: number;
  public qualityParamDetails: CustomParametersDetailsModel;
  customParamIndex: number = -1;
  selectedPackMaterialId: number;
  selectedDetailsMaterialId: number;
  private packingList: PackingModel[];

  public isQualityParamOn: boolean;
  public isPkgTypeSupportOn: boolean;
  public moduleParams: soModuleParamConfigModel = new soModuleParamConfigModel(this.moduleParamConfigGlob);
  public sysConfigModel: SystemConfigSettingModel = new SystemConfigSettingModel(this.systemConfigService);
  public isImlUpdate: boolean;
  public setNoCount: number = 0;
  organization: OrgProfileModal;
  public isCgst: boolean = false;
  public isIgst: boolean = false;
  staffList: Array<UserModal>;
  isDiagonal: boolean;
  isHideHeaderFooter: boolean;
  public stockInventory: Array<ProductionBatchOptimisedModal>;
  public dataListByName: Array<InwardStockByName>;
  public mainDataListByNameInward: Array<InwardStockByName>;
  finalAmountTotal: number;
  public list: InwardStockFilterList[];
  moduleId: number;
  isPrintAllowed: boolean;
  isWorkOrder: boolean;
  isLifeoline: boolean;
  isSalesorderSendMail : boolean;
  isAlaska:boolean;
  paramobj = new DynamicParams();
  paramArray = new Array<DynamicParams>();
  isApprovalFlowOn = false;
  shippingdate: Date;
  public isproformainvoice = false;
  
  constructor(
    public service: SalesOrderServiceService,
    public commonSerivce: CommonSelectListService,
    public router: Router,
    private aclService: ACLService,
    public toastrService: ToastrService,
    private activeRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private ngbModalService: NgbModal,
    private systemConfigService: SystemConfigService,
    private moduleParamConfigGlob: ModuleParamGlobConfigService,
    public confirmationDialogService: ConfirmDialogService
  ) {
    super(toastrService, router);
  }

  ngOnInit() {
    this.getOrganizationData();
    this.isDiagonal = this.sysConfigModel.partnerKey == 'Diagonal';
    this.isAlaska = this.sysConfigModel.partnerKey == 'Alaska';
    if (this.sysConfigModel.partnerKey == 'Alaska' && this.sysConfigModel.printPartner == 'Lifeoline') {
      this.isLifeoline = true;
    } else {
      this.isLifeoline = false;
    }
    this.isHideHeaderFooter = false;
    this.isQualityParamOn = this.systemConfigService.sysConfig
      ? this.systemConfigService.sysConfig.get('QUALITY_PARAM_ON') === 'YES'
      : false;
    this.isPkgTypeSupportOn = this.systemConfigService.sysConfig
      ? this.systemConfigService.sysConfig.get('PACKING_TYPE_SUPPORT') === 'YES'
      : false;
      this.isSalesorderSendMail = this.systemConfigService.sysConfig
      ? this.systemConfigService.sysConfig.get('SALES_ORDER_SEND_MAIL') === 'YES'
      : false;

      this.isproformainvoice = this.systemConfigService.sysConfig && this.systemConfigService.sysConfig.get('ADD_PROFORMA_INVOICE') == 'YES';
    this.init();
    this.getDefaultDate();
    if(!this.isUpdateComponent){
      this.shippingdate = new Date();
      this.shippingdate.setDate(this.data.date.getDate() - 1);
    }
    this.getPartyList();
    if (this.isPkgTypeSupportOn) this.getPackingList();
    if (this.sysConfigModel.isPartLedger) this.checkUserRole();
    this.getStaffList();
    this.getFreight();
    this.initTransporterList();
    this.initSysConfig();
    if (!this.isUpdateComponent) {
      this.getSONo();
    }
    this.sysInit();
    
    if(this.sodata){
      console.log('soData =>',this.sodata)
      this.data = this.sodata;
    }
  }

  changedate(date){
    this.shippingdate = new Date();
    this.shippingdate.setDate(this.data.customerExpectedDate.getDate() - 1);
  }
  sysInit() {
    this.isSecondaryQuantity = this.configurationCheck('SECONDARY_STOCK_SUPPORT');
  }
  configurationCheck(param: string) {
    return this.systemConfigService.sysConfig ? this.systemConfigService.sysConfig.get(param) === 'YES' : false;
  }

  getDefaultDate() {
    let loggedInUser = JSON.parse(localStorage.getItem('activeUser'));
    if (this.sysConfigModel.defaultSystemDate && loggedInUser.role.roleid != 1) {
      this.formGroup.get('date').disable();
      this.formGroup.get('soNumber').disable();
      this.formGroup.get('createdBy').disable();
      this.formGroup.updateValueAndValidity();
    }
    if (!this.isUpdateComponent && this.data) {
      if (!this.isUpdateComponent) {
        let loggedInStaff: UserModal = JSON.parse(localStorage.getItem('activeUser'));
        this.data.createdBy = loggedInStaff;
      }
      this.data.date = new Date();
    }
  }

  getFreight() {
    this.commonSerivce.getFreightList().subscribe((res) => {
      this.freightTypeList = new Array<FreightModal>();
      this.freightTypeList = res.dataList;
    });
  }

  initTransporterList() {
    this.transporterList = [
      { id: 1, name: 'ABC Transport' },
      { id: 2, name: 'XYZ Logistics' },
      { id: 3, name: 'Fast Track Courier' },
      { id: 4, name: 'Global Shipping' },
      { id: 5, name: 'Express Delivery' },
      { id: 6, name: 'Reliable Transport' },
      { id: 7, name: 'Speed Logistics' },
      { id: 8, name: 'Nationwide Transport' }
    ];
  }

  getStaffList() {
    this.commonSerivce.getStaffList().subscribe((response) => {
      this.validateResponse(response, () => {
        this.staffList = new Array<UserModal>();
        this.staffList = response.dataList;
      });
    });
  }

  private initSysConfig() {
    this.isVendorCodeOn = this.systemConfigService.sysConfig
      ? this.systemConfigService.sysConfig.get('VENDOR_CODE_ON') === 'YES'
      : false;

    this.isPackingTypeSupport = this.systemConfigService.sysConfig
      ? this.systemConfigService.sysConfig.get('PACKING_TYPE_SUPPORT') === 'YES'
      : false;

    this.isRollNoSupport = this.systemConfigService.sysConfig
      ? this.systemConfigService.sysConfig.get('ROLL_NO_SUPPORT') === 'YES'
      : false;

    this.isSecondaryStockSupport = this.systemConfigService.sysConfig
      ? this.systemConfigService.sysConfig.get('SECONDARY_STOCK_SUPPORT') === 'YES'
      : false;
  }
  getPackingList() {
    this.commonSerivce.getPackingList().subscribe((response) => {
      this.validateResponse(response, () => {
        this.packingList = new Array<PackingModel>();
        this.packingList = response.dataList;
        if (this.isUpdateComponent) {
          if (this.data.salesOrderItemDetails && this.data.salesOrderItemDetails.length !== 0) {
            this.data.salesOrderItemDetails.forEach((list) => {
              list.selectedPacking = new PackingModel();
              list.selectedPackageCapacity = new PackingDetailModel();
              list.selectedPacking = this.packingList.find((pac) => pac.id === list.packingType);
              if (list.selectedPacking && list.selectedPacking.capacityDetails) {
                list.selectedPacking.capacityDetails.forEach((lit) => {
                  if (lit.packingUOM && lit.packingUOM.capacityDetails) {
                    lit.subPackingCapacity = lit.packingUOM.capacityDetails.find(
                      (sub) => sub.id === lit.packingUOMCapacity
                    );
                  }
                });
                list.selectedPackageCapacity = list.selectedPacking.capacityDetails.find(
                  (pc) => pc.id === list.packingCapacityDetails
                );
              }
            });
          }
        }
      });
    });
  }

  getDataFromInverntory(reqDto) {
    this.commonSerivce.getAllInwardStockOptimised(reqDto).subscribe((res) => {
      // this.stockInventory = new DispatchDetailsModal();
      this.stockInventory = [];
      this.stockInventory = res.dataList;
      this.stockInventory = res.dataList.filter((ls) => !ls.partyId);
      this.list = new Array<InwardStockFilterList>();
      ArrayUtils._groupByWithOneKey(this.stockInventory, 'itemId').subscribe(
        (response: Array<Array<InwardStockModal>>) => {
          this.dataListByName = new Array<InwardStockByName>();
          response.forEach((value) => {
            let nameData: InwardStockByName = new InwardStockByName();
            //nameData.product = value[0].product;
            nameData.item = new ProductModal();
            nameData.item.name = value[0]['itemName'];
            nameData.item.productCode = value[0]['productCode'];
            nameData.item.uom = new UomModal();
            nameData.item.uom.name = value[0]['uom'];
            nameData.item.secondaryUom = new UomConstModal();
            nameData.item.secondaryUom.name = value[0]['secondaryUom'];
            nameData.dataList = value;
            nameData.productTypes = value[0].productTypes;
            nameData.total = 0;
            nameData.totalBlockStock = 0;
            nameData.totalSecondaryStock = 0;
            nameData.typeList = value[0].typeList;
            value.forEach((value1) => {
              if (value1.packingType && value1.packingCapacityType) {
                nameData.total =
                  parseFloat('' + nameData.total) + parseFloat('' + value1.stock * value1.packingCapacityType.capacity);
              } else {
                nameData.total = parseFloat('' + nameData.total) + parseFloat('' + value1.stock);
              }

              nameData.totalBlockStock =
                parseFloat('' + nameData.totalBlockStock) + parseFloat('' + value1.blockedStock);

              if (value1.secondaryStock) {
                nameData.totalSecondaryStock =
                  parseFloat('' + nameData.totalSecondaryStock) + parseFloat('' + value1.secondaryStock);
              }
            });

            // customItemNumber
            const tempdata = nameData.dataList;
            const temparray = [];
            nameData.dataList.forEach((item) => {
              item.item = new ProductModal();
              item.item.name = item['itemName'];
              item.item.productCode = item['productCode'];
              item.item.uom = new UomModal();
              item.item.uom.name = item['uom'];
              item.item.secondaryUom = new UomConstModal();
              item.item.secondaryUom.name = item['secondaryUom'];
              item.party = new PartyModal();
              item.party.id = item['partyId'];
              item.party.companyName = item['partyName'];
              let sidV: any = 0;
              if (item.customItemNumber && item.customItemNumber != '') {
                let tamparray = item.customItemNumber.split('-');
                sidV = tamparray[1];
              }
              item['sidv'] = sidV;
            });
            let newNameData = nameData.dataList.sort((a: any, b: any) => a.sidv - b.sidv);
            nameData.dataList = newNameData;

            this.dataListByName.push(nameData);
          });
          this.mainDataListByNameInward = JSON.parse(JSON.stringify(this.dataListByName));
        }
      );
    });
  }

  getService(): IBaseService<SalesOrderModal> {
    return this.service;
  }

  public getPartyList() {
    this.commonSerivce.getCustomerListOptimized().subscribe((res) => {
      this.validateResponse(res, () => {
        this.partyList = new Array<PartyModal>();
        this.partyList = res.dataList;
        if (this.selectedParty) {
          if (!this.data) this.data = new SalesOrderModal();
          if (this.data && !this.data.party) this.data.party = new PartyModal();
          this.data.party = this.partyList.find((ls) => ls.id === this.selectedParty.id);
        }
      });
    });
  }

  setData(data: SalesOrderModal) {
    this.data = data;
    if (this.data && !this.data.generatedFrom) {
      this.data.generatedFrom = this.moduleParams.paramData.so_from_label.label;
    }

    // if(this.data && this.data.date){
    //   debugger
    //   this.shippingdate = new Date();
    //   this.shippingdate.setDate(this.data.date.getDate() - 1)
    // }
    if (this.data && this.data.customerExpectedDate) {
      this.data.customerExpectedDate = new Date(this.data.customerExpectedDate);
      this.formGroup.get('customerExpectedDate').setValue(this.data.customerExpectedDate);
    }
    if (this.data && this.data.estimatedShippingDate) {
      this.data.estimatedShippingDate = new Date(this.data.estimatedShippingDate);
    }
    if (this.data && this.data.actualCompletionDate) {
      this.data.actualCompletionDateFormat = new Date(this.data.actualCompletionDate);
    }
    if (this.data && this.data.tentativeCompletionDate) {
      this.data.tentativeCompletionDateFormat = new Date(this.data.tentativeCompletionDate);
    }

    if (this.data && this.data.salesOrderItemDetails && this.sysConfigModel.labelSupport) {
      this.data.salesOrderItemDetails.sort((a, b) => (a.id < b.id ? 1 : -1));

      let oldItem = undefined;
      let salesOrderItemDetails = [];
      // this.data.salesOrderItemDetails.forEach((item, index) => {
      //   if (item.setNo && item.isSet) {
      //     this.setNoCount++;
      //   }

      //   if (oldItem && item.setNo === oldItem.setNo && item.isSet) {
      //     const oldind = salesOrderItemDetails.indexOf(oldItem);

      //     if (salesOrderItemDetails[oldind] && !salesOrderItemDetails[oldind]['details']) {
      //       salesOrderItemDetails[oldind]['details'] = item;
      //     }
      //   } else {
      //     salesOrderItemDetails.push(item);
      //     oldItem = item;
      //   }
      // });

      // this.data.salesOrderItemDetails = salesOrderItemDetails;
    }

    let obj = {
      keyName: 'so_approval_flow',
    };

    this.commonSerivce.getModuleApproval(obj).subscribe((res) => {
      if (res.data && res.data.id) this.moduleId = res.data.id;
      if (!this.isUpdateComponent) {
        if (res.data && res.data.isActive) {
          this.isApprovalFlowOn = true;
          this.data.approvalStatus = { id: 1, statusName: 'Approval Pending' };
        } else {
          this.isApprovalFlowOn = false;
          this.data.approvalStatus = { id: 3, statusName: 'Approved By Head' };
        }
      }
      if (this.moduleId) {
        if (this.data && this.data.approvalStatus && this.isUpdateComponent) {
          this.isEditAllow = false;
          this.isPrintAllowed = true;
        } else {
          this.isPrintAllowed = false;
        }
      }
      this.getWeightTotal();
    });

    if (!this.isUpdateComponent && this.data) {
      this.getUniqueSO();
    }

    this.getOrganizationData();
  }

  getUniqueSO() {
    this.service.getSoNumber().subscribe((data) => {
      if (data.responseCode === 200) {
        this.data.soNumber = data.data;
      }
    });
  }

  getData(): SalesOrderModal {
    if (this.data && this.data.salesOrderItemDetails) {
      let salesOrderItemDetails = [];
      this.data.salesOrderItemDetails.forEach((item: any) => {
        if (item.details && item.details.setNo) {
          salesOrderItemDetails.push(item.details);
          item.details = undefined;
        }
        salesOrderItemDetails.push(item);
      });
      this.data.salesOrderItemDetails = salesOrderItemDetails;
    }
    return this.data;
  }

  public getModuleHomeUrl(): string {
    if (this.getAllFilter) {
      return this.router.url;
    }

    if(this.isModelComponent){
      return '/module/quotation/list'
    } else {
      return '/module/sales-order/salesOrderList';
    }
  }

  public getActiveRoute(): ActivatedRoute {
    if (this.getAllFilter) {
      return (this.activeRoute = new ActivatedRoute());
    }
    return this.activeRoute;
  }

  public getNewModal(): SalesOrderModal {
    return new SalesOrderModal();
  }

  public getFormGroup(): FormGroup {
    return this.formGroup;
  }

  setValidation() {
    this.formGroup = this.formBuilder.group({
      date: ['', Validators.required],
      customerExpectedDate: ['',Validators.required],
      estimatedShippingDate: ['',Validators.required],
      freightType: [''],
      serviceprice: [''],
      tentativeCompletionDate: [{ value: '', disabled: true }],
      actualCompletionDate: [{ value: '', disabled: true }],
      name: [
        '',
        this.moduleParamConfigGlob.isRequired(this.MODULE_PARAM_CONFIG_KEY, 'so_name') ? Validators.required : '',
      ],
      soNumber: [{ value: '' }, Validators.required],
      party: [
        '',
        this.moduleParamConfigGlob.isRequired(this.MODULE_PARAM_CONFIG_KEY, 'party_name') ? Validators.required : '',
      ],
      remark: [''],
      poReference: [
        '',
        this.moduleParamConfigGlob.isRequired(this.MODULE_PARAM_CONFIG_KEY, 'po_reference') ? Validators.required : '',
      ],
      poDate: [
        '',
        this.moduleParamConfigGlob.isRequired(this.MODULE_PARAM_CONFIG_KEY, 'po_date') ? Validators.required : '',
      ],
      termsOfPayment: [
        '',
        this.moduleParamConfigGlob.isRequired(this.MODULE_PARAM_CONFIG_KEY, 'terms_of_payment')
          ? Validators.required
          : '',
      ],
      createdBy: [''],
      freight: [''],
      contactDetail: [''],
      shippingAddress: [''],
      transporter: [''],
    });
    if (this.selectedParty) {
      this.formGroup.controls.party.disable();
    }
  }

  public getId(): number {
    return this.data.id;
  }

  get f() {
    return this.formGroup.controls;
  }

  refreshPrompt() {
    setTimeout(() => {
      if (confirm('Do you want to refresh Party List?')) {
        this.getPartyList();
      }
    }, 5000);
  }

  onAddClick(content, stockData: SoDetailModal) {
    let temp = {};
    if (stockData && stockData.itemProperties) {
      temp['itemProperties'] = stockData.itemProperties;
      temp['itemId'] = stockData.item.id;
      this.getDataFromInverntory(temp);
    }

    this.targetProductIndex = -1;
    this.productDetail = new SoDetailModal();
    this.isImlUpdate = false;
    this.ngbRef = this.ngbModalService.open(content, { windowClass: 'xxlModal', backdrop: 'static' });
  }

  getColspan() {
    if (this.isSecondaryStockSupport && this.sysConfigModel.isRackSupport) {
      return 10;
    } else if (this.isSecondaryStockSupport) {
      return 8;
    } else if (this.sysConfigModel.isRackSupport) {
      return 9;
    } else {
      return 6;
    }
  }

  onStockAddClick(content) {
    this.ngbRef = this.ngbModalService.open(content, { size: 'lg', backdrop: 'static' });
  }

  public onEdit(index: number, content) {
    this.targetProductIndex = index;
    this.productDetail = Object.assign({}, this.data.salesOrderItemDetails[index]);
    this.ngbRef = this.ngbModalService.open(content, { windowClass: 'xxlModal', backdrop: 'static' });
  }

  public onDelete(i: number) {
    if (confirm('Are you sure?')) {
      this.data.salesOrderItemDetails.splice(i, 1);
      this.getWeightTotal();
    }
  }

  setGrandTotal() {
    let totalFreight = 0,
      totalFreightGST = 0,
      totalFreightOnlyGST = 0;
    if (this.data.freightValue && this.data.freight) {
      totalFreight = this.data.freight * this.data.freightValue.value;
      if (!totalFreight || totalFreight != 0) totalFreightOnlyGST = totalFreight / 100;
      totalFreightGST = Number(this.data.freight) + Number(totalFreightOnlyGST);
    }

    this.data.grandTotal = totalFreightGST + this.finalAmountTotal;
  }

  onProductSave(eventData: any) {
    if (!this.data.salesOrderItemDetails || this.data.salesOrderItemDetails.length === 0) {
      this.data.salesOrderItemDetails = new Array<SoDetailModal>();
    }
    if (this.targetProductIndex >= 0) {
      this.data.salesOrderItemDetails[this.targetProductIndex] = eventData;
    } else {
      this.data.salesOrderItemDetails.push(eventData);
    }

    this.targetProductIndex = -1;
    this.getWeightTotal();
    this.ngbRef.close();
  }

  public onProductCancel(event) {
    this.targetProductIndex = -1;
    this.ngbRef.close();
  }
  onBlur() {}

  onPurchaseOrderListSave(event) {
    if (!this.data.salesOrderItemDetails || this.data.salesOrderItemDetails.length === 0) {
      this.data.salesOrderItemDetails = new Array<SoDetailModal>();
      this.data.salesOrderItemDetails = event;
    } else {
      this.data.salesOrderItemDetails = this.data.salesOrderItemDetails.concat(event);
    }

    this.targetProductIndex = -1;
    this.getWeightTotal();
    this.ngbRef.close();
    this.isImlUpdate = false;
  }

  getOrganizationData() {
    this.commonSerivce.getOrganizationData().subscribe((res) => {
      this.organization = new OrgProfileModal();
      this.organization = res.data;
    });
  }

  getWeightTotal() {
    
    if (this.data && this.data.party && this.data.party.gstNumber && this.organization && this.organization.gstin) {
      if (this.organization.gstin.slice(0, 2) === this.data.party.gstNumber.slice(0, 2)) {
        this.isCgst = true;
      } else {
        this.isIgst = true;
      }
    }

    this.totalWeight = 0;
    this.totalSecondaryWeight = 0;
    this.totalCost = 0;
    this.finalAmountTotal = 0;
    if (this.data.salesOrderItemDetails) {
      // this.totalWeight = this.data.salesOrderItemDetails.reduce(
      //   (sum, item) => sum + parseFloat('' + (item.weight ? item.weight : 0)),
      //   0
      // );

      this.data.salesOrderItemDetails.forEach((item: any) => {
        if (!item.isDeleted) {
          this.totalWeight = this.totalWeight + parseFloat('' + item.weight);
          this.totalSecondaryWeight = this.totalSecondaryWeight + parseFloat('' + item.receivedSecondaryQuantity);
          this.totalCost = this.totalCost + parseFloat('' + item.price * item.weight);
          if (item.details) {
            const price = item.details.price || 0;
            const weight = item.details.weight || 0;

            this.totalCost = this.totalCost + parseFloat('' + price * weight);
          }
        }
      });

      this.data.salesOrderItemDetails.forEach((ls) => {
        if (ls.discount && ls.discount !== 0) {
          ls.taxableAmount = ls.price * ls.weight;
          ls.finalAmout = ls.price * ls.weight - (ls.discount * ls.price * ls.weight) / 100;
        } else {
          ls.finalAmout = ls.price * ls.weight;
        }
        if (ls.gst && ls.gst !== 0) {
          let tempGst;
          if(this.isDiagonal){
             tempGst = (ls.gst * ls.finalAmout) / 100;
          } else {
            tempGst = Math.floor((ls.gst * ls.finalAmout) / 100);
          }
          ls.gstAmount = tempGst;
          ls.finalAmout += tempGst;
        }
        this.finalAmountTotal += ls.finalAmout;
      });

      // this.totalCost = this.data.salesOrderItemDetails.reduce(
      //   (sum, item) => sum + parseFloat('' + item.price * item.weight) + (item.details ? parseFloat(item.details.price * item.details.weight) : 0),
      //   0
      // );
      this.setGrandTotal();
    }
  }

  onSlipPrintClick(printContent: TemplateRef<any>, onSave?: boolean) {
    if (this.formGroup.invalid) {
      this.submitted = true;
      return this.toastrService.warning('Please Enter All Required Fields', 'WARNING');
    }
    if (!this.data.salesOrderItemDetails || this.data.salesOrderItemDetails.length == 0) {
      return this.toastrService.warning('Please Add At least One Item In Shipment Order', 'WARNING');
    }
    if (this.data.freightValue) {
      if (this.data.freight == '' || this.data.freight == null) {
        return this.toastrService.error('Please Enter Freight Price');
      } else if (this.data.freight == 0) {
        return this.toastrService.error("Entered Freight Price Can't be Zero");
      }
    }
    this.onPrintUpdate(onSave);
    // this.isHideHeaderFooter = false;
    this.isHideHeaderFooter = false;
    this.isWorkOrder = false;
    this.ngbRef = this.ngbModalService.open(printContent, { size: 'lg', backdrop: 'static' });
    let cb1 = document.getElementById('checkbox1');
    cb1['checked'] = true;
    let cb = document.getElementById('checkbox');
    cb['checked'] = false;

    setTimeout(() => {
      if (this.isLifeoline) {
        let cbWs1 = document.getElementById('checkboxWs1');
        cbWs1['checked'] = true;
        let cbWs = document.getElementById('checkboxWs');
        cbWs['checked'] = false;
      }
    }, 100);
    this.ngbRef.close();
    this.ngbRef = this.ngbModalService.open(printContent, { size: 'lg', backdrop: 'static' });
  }

  onPrintUpdate(onSave?: boolean) {
    if (!onSave) {
      this.service.update(this.getData()).subscribe((res) => {
        if (res.responseCode && res.responseCode == ResponseCode.OK) {
          this.toastrService.success('Data Has Been Updated Successfully', 'SUCCESS');
        } else {
          this.toastrService.success(res.responseMessage, 'ERROR');
        }
      });
    }
  }

  onSalesOrderPreviewAndSave(event?: any) {
    this.ngbRef.close();
    this.onSaveSO(this.data, event);
  }

  getValidationforfreightprice(data) {
    if (data.freightType) {
      if (data.freight === 0) return true;
      else return false;
    }
  }

  onSubmit() {
    this.submitted = true;
    if (this.getFormGroup().invalid) {
      this.toastrService.error('Please fill all the details', 'Error');
      return;
    }
    if (this.data && !this.isUpdateComponent && !this.sodata) {
      this.data.generatedFrom = this.moduleParams.paramData.so_from_label.label;
    }

    /** for CBL use these code is mandatory **/
    if (this.cblChild) {
      this.data.company = new OrgProfileModal();
      this.data.company = this.cblChild.selectedCompany ? this.cblChild.selectedCompany : undefined;

      this.data.branch = new BranchModel();
      this.data.branch = this.cblChild.selectedBranch ? this.cblChild.selectedBranch : undefined;

      this.data.location = new LocationMasterModel();
      this.data.location = this.cblChild.selectedLocation ? this.cblChild.selectedLocation : undefined;
    }

    if (this.cblChild && this.cblChild.cblFormGroup.invalid) {
      return this.toastrService.error('Please fill all the details', 'Error');
    }

    if (this.data.freightValue) {
      if (this.data.freight == '' || this.data.freight == null) {
        return this.toastrService.error('Please Enter Freight Price');
      } else if (this.data.freight == 0) {
        return this.toastrService.error("Entered Freight Price Can't be Zero");
      }
    }

    if (!this.isUpdateComponent) this.onSaveSO(this.data);
    else super.onSubmitV2();
  }

  onSaveSO(modal: SalesOrderModal, event?: any) {
    console.log('event =>', event);

    this.getService()
      .saveV2(modal)
      .subscribe(
        (response) => {
          this.validateResponse(response, () => {
            this.submitted = false;
            const responseParty = response.data;
            let obj = {
              entityId: responseParty.id,
              moduleId: this.moduleId,
            };
            if(event != undefined){
              if (event.amendedPoNo) {
                this.paramobj = new DynamicParams();
                this.paramobj.keyName = amendedPoNo;
                this.paramobj.value = event.amendedPoNo;
                this.paramobj.valueObject = null;
                this.paramobj.entityId = responseParty.id;
                this.paramobj.moduleName = moduleName;
                this.paramArray.push(this.paramobj);
              }
              if (event.amendedPoDate) {
                this.paramobj = new DynamicParams();
                this.paramobj.keyName = amendedPoDate;
                this.paramobj.value = event.amendedPoDate;
                this.paramobj.valueObject = null;
                this.paramobj.entityId = responseParty.id;
                this.paramobj.moduleName = moduleName;
                this.paramArray.push(this.paramobj);
              }
              if (event.selectedDeliveryNote && event.selectedDeliveryNote.length > 0) {
                this.paramobj = new DynamicParams();
                this.paramobj.keyName = selectedDeliveryNote;
                this.paramobj.value = null;
                this.paramobj.valueObject = event.selectedDeliveryNote;
                this.paramobj.entityId = responseParty.id;
                this.paramobj.moduleName = moduleName;
                this.paramArray.push(this.paramobj);
              }
              if (event.selectedDocumentNotes && event.selectedDocumentNotes.length > 0) {
                this.paramobj = new DynamicParams();
                this.paramobj.keyName = selectedDocumentNotes;
                this.paramobj.value = null;
                this.paramobj.valueObject = event.selectedDocumentNotes;
                this.paramobj.entityId = responseParty.id;
                this.paramobj.moduleName = moduleName;
                this.paramArray.push(this.paramobj);
              }
              if (event.spiIns) {
                this.paramobj = new DynamicParams();
                this.paramobj.keyName = spiIns;
                this.paramobj.value = event.spiIns;
                this.paramobj.valueObject = null;
                this.paramobj.entityId = responseParty.id;
                this.paramobj.moduleName = moduleName;
                this.paramArray.push(this.paramobj);
              }
            }
            if (this.paramArray.length > 0) {
              this.service.getPrintParameters(this.paramArray).subscribe((res) => {
                console.log('abc=>', res);
              });
            }
            
            if(this.isSalesorderSendMail){
              if (!this.isApprovalFlowOn) {
                if (event) {
                  event.soId = responseParty.id;
                  event.salesOrder = responseParty;
                  this.service.sendMailOnSave(event);
                } else {
                  let data = {};
                  data['soId'] = responseParty.id;
                  data['salesOrder'] = responseParty;
                  this.service.sendMailOnSave(data);
                }
              }
            }
            this.commonSerivce.reqToApprove(obj).subscribe((res) => {});
            if(this.isModelComponent){
              this.saveCallback.emit(response.data);
            }
            this.toastrService.success('Data has been save successfully.', 'Success');
            this.router.navigate([this.getModuleHomeUrl()]);
          });
        },
        (error) => {
          this.onResponseError(error.message);
        }
      );
  }

  onSaveSuccess() {
    if (this.getAllFilter) {
      this.onSaveCallBack.emit();
    }
    super.onSaveSuccess();
  }

  onCancel() {
    if (this.getAllFilter) this.onSaveCallBack.emit();
    super.onCancel();
  }

  getQualityParametersValue(i: number, j: number, about: string) {
    const param = this.data.salesOrderItemDetails[i].salesOrderQualityParamDetails[j];

    if (about === 'value') {
      if (param.customParam.type.keyName.toLowerCase() === 'range') {
        if (!param.value1 || !param.value2) {
          return 'Not Specified';
        }
        return `${param.value1} to ${param.value2}`;
      }

      if (!param.defaultValue) {
        return 'Not Specified';
      }
      return `${param.defaultValue}`;
    }

    if (about === 'tolerance') {
      if (
        param.customParam.type.keyName.toLowerCase() === 'list' ||
        param.customParam.type.keyName.toLowerCase() === 'boolean'
      ) {
        return 'Not Applicable';
      }
      if (!param.tolerance) {
        return 'Not Specified';
      }
      return `${param.tolerance}`;
    }
  }

  onEditCustomParam(i: number, j: number, customParams) {
    this.customParamIndex = j;
    this.qualityParamDetails = Object.assign({}, this.data.salesOrderItemDetails[i].salesOrderQualityParamDetails[j]);
    this.ngbRef = this.ngbModalService.open(customParams, { windowClass: 'xxlModal', backdrop: 'static' });
  }

  onDeleteCustomParam(i: number, j: number) {
    if (confirm('Are you sure?')) {
      this.data.salesOrderItemDetails[i].salesOrderQualityParamDetails.splice(j, 1);
      // this.data.salesOrderItemDetails[i].salesOrderQualityParamDetails[j]['isDeleted'] = true ;;
    }
  }

  onAddCustomParamClick(index: number, customParams) {
    this.customParamIndex = -1;
    this.qualityParamDetails = new CustomParametersDetailsModel();
    this.ngbRef = this.ngbModalService.open(customParams, { size: 'lg', backdrop: 'static' });
  }

  saveCustomParam(event: CustomParametersDetailsModel) {
    if (
      this.data.salesOrderItemDetails[this.selectedMaterialId] &&
      (!this.data.salesOrderItemDetails[this.selectedMaterialId].salesOrderQualityParamDetails ||
        this.data.salesOrderItemDetails[this.selectedMaterialId].salesOrderQualityParamDetails.length === 0)
    ) {
      this.data.salesOrderItemDetails[this.selectedMaterialId].salesOrderQualityParamDetails =
        new Array<SalesOrderQualityParamDetailsModel>();
    }

    if (this.customParamIndex >= 0) {
      this.data.salesOrderItemDetails[this.selectedMaterialId].salesOrderQualityParamDetails[this.customParamIndex] =
        event;
    } else {
      this.data.salesOrderItemDetails[this.selectedMaterialId].salesOrderQualityParamDetails.push(event);
    }

    this.customParamIndex = -1;
    this.ngbRef.close();
  }

  getNumberOfColumns(): number {
    if (this.isQualityParamOn && this.isPkgTypeSupportOn) return 12;
    else if (!this.isQualityParamOn && !this.isPkgTypeSupportOn) return 10;
    else return 11;
  }

  ngAfterContentInit() {
    this.moduleParams = new soModuleParamConfigModel(this.moduleParamConfigGlob);
  }

  onSelectParty() {
    this.data.contactDetail = undefined;
    if (this.data.party) {
      this.commonSerivce.getPartyById(this.data.party.id).subscribe((res) => {
        this.data.party = res.data;
        var party = this.data.party;
        if (this.data.party.contactDetails && this.data.party.contactDetails.length == 1) {
          this.data.contactDetail = new Array<PartyDetailModal>();
          this.data.contactDetail.push(this.data.party.contactDetails[0]);
        }
        this.data.shippingAddress =
          (party.shippingAddress ? party.shippingAddress : '') +
          ' ' +
          (party.shippingAddress2 ? party.shippingAddress2 : '') +
          ' ' +
          (party.shippingAddress3 ? party.shippingAddress3 : '');
      });
    } else {
      this.data.shippingAddress = '';
    }
  }

  getSONo() {
    this.service.getSoNumber().subscribe((s) => {
      this.data.soNumber = s.data;
    });
  }

  checkUserRole() {
    this.aclService.getLoggedInUser().subscribe((response) => {
      this.validateResponse(response, () => {
        if (!this.isUpdateComponent) {
          if (!this.data) {
            this.data = new SalesOrderModal();
          }
          if (this.data && !this.data.salesHead) {
            this.data.salesHead = new UserModal();
            this.data.salesHead = JSON.parse(JSON.stringify(response.data));
          }
        }
      });
    });
  }

  // purpose: Do not show toaster in case of 422 status code
  save(modal) {
    this.getService()
      .save(modal)
      .subscribe(
        (response) => {
          if (response.responseCode != ResponseCode.OK && response.responseCode != 422) {
            this.onResponseError(response.responseMessage);
            return;
          }
          this.onSavedCallback.emit(response.data);
          this.onSaveSuccess();
        },
        (error) => {
          this.onResponseError(error.message);
        }
      );
  }

  public openConfirmationDialog(email) {
    this.confirmationDialogService
      .confirm('Please confirm..', 'Do you really want to send Quotation?', 'Send Mail')
      .then((confirmed) => (confirmed ? this.onSendMailDialog(email) : this.ngbRef.close()))
      .catch(() =>
        console.log(
          'User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'
        )
      );
  }

  onSendMailDialog(email) {
    this.ngbRef = this.ngbModalService.open(email, { windowClass: 'mdModal', backdrop: 'static' });
  }

  onSendMail(event: SOMailModel) {
    this.service.sendMail(event).subscribe((response) => {
      this.validateResponse(response, () => {
        this.ngbRef.close();
        this.toastrService.success('Shipment Order Mail send Successfully', 'SUCCESS');
        if (!this.isUpdateComponent) {
          this.onSubmit();
        }
      });
    });
  }

  onSalesOrderPrintClick(soPrint) {
    this.isHideHeaderFooter = false;
    this.isWorkOrder = false;
    this.ngbRef = this.ngbModalService.open(soPrint, { size: 'lg', backdrop: 'static' });
    let cb1 = document.getElementById('checkbox1');
    cb1['checked'] = true;
    let cb = document.getElementById('checkbox');
    cb['checked'] = false;
    setTimeout(() => {
      if (this.isLifeoline) {
        let cbWs1 = document.getElementById('checkboxWs1');
        cbWs1['checked'] = true;
        let cbWs = document.getElementById('checkboxWs');
        cbWs['checked'] = false;
      }
    }, 100);

    this.printData = new SalesOrderModal();
    this.printData = this.data;
  }

  oninvoicePrintClick(soPrint) {
    this.isHideHeaderFooter = false;
    this.isWorkOrder = false;
    this.ngbRef = this.ngbModalService.open(soPrint, { size: 'lg', backdrop: 'static' });
    let cb1 = document.getElementById('checkbox1');
    cb1['checked'] = true;
    let cb = document.getElementById('checkbox');
    cb['checked'] = false;
    setTimeout(() => {
      if (this.isLifeoline) {
        let cbWs1 = document.getElementById('checkboxWs1');
        cbWs1['checked'] = true;
        let cbWs = document.getElementById('checkboxWs');
        cbWs['checked'] = false;
      }
    }, 100);

    this.printData = new SalesOrderModal();
    this.printData = this.data;
  }

  onClickHideHeaderFooter(hide: boolean) {
    let cb = document.getElementById('checkbox');
    let cb1 = document.getElementById('checkbox1');
    if (hide) {
      cb['checked'] = true;
      cb1['checked'] = false;
      this.isHideHeaderFooter = true;
    } else {
      cb['checked'] = false;
      cb1['checked'] = true;
      this.isHideHeaderFooter = false;
    }
  }

  onClickWorkOrderOrSalesOrder(hide: boolean) {
    let cb = document.getElementById('checkboxWs');
    let cb1 = document.getElementById('checkboxWs1');
    if (hide) {
      cb['checked'] = true;
      cb1['checked'] = false;
      this.isWorkOrder = true;
    } else {
      cb['checked'] = false;
      cb1['checked'] = true;
      this.isWorkOrder = false;
    }
  }

  onClickSalesOrderPrint(printContent) {
    this.ngbRef.close();
    //this.isHideHeaderFooter = !this.isHideHeaderFooter;
    this.ngbRef = this.ngbModalService.open(printContent, { windowClass: 'xxlModal', backdrop: 'static' });
  }
  
  onClickInvoicePrint(printContent) {
    this.ngbRef.close();
    //this.isHideHeaderFooter = !this.isHideHeaderFooter;
    this.ngbRef = this.ngbModalService.open(printContent, { windowClass: 'xxlModal', backdrop: 'static' });
  }
}
